import styled, { css } from 'styled-components';

export interface BadgeProps {
    text?: string;
    variant?: 'blue' | 'grey' | 'flat';
}

export const Wrapper = styled.div<BadgeProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 17px;

    border-radius: 100px;

    padding: 0 6px;

    color: #fff;
    background: rgba(255, 255, 255, 0.2);

    font-weight: 600;
    font-size: 9px;
    line-height: 100%;
    text-align: center;

    color: #ffffff;

    ${({ variant }) => {
        if (variant === 'blue') {
            return css`
                background: linear-gradient(180deg, #6e3ef4 0%, #2d17b8 100%);
            `;
        } else if (variant === 'grey') {
            return css`
                background: linear-gradient(180deg, #686080 0%, #2a2637 100%);
            `;
        }
    }}
`;
